import React, { useEffect, useState } from "react";
import { BsBookmark, BsBookmarkFill } from "react-icons/bs";
import AxiosInstance from "../Home/AxiosInstance";
import "./SaveButton.css";

export const SAVED_TYPES = {
  JOB: "Job",
  INTERNSHIP: "Internship",
  TRAINING: "Training",
};

export function fetchSavedItems(traineeId) {
  return AxiosInstance.get(`companies/trainee/${traineeId}/saved/`).then(
    (res) => ({
      jobs: Array.isArray(res.data?.jobs) ? res.data.jobs : [],
      internships: Array.isArray(res.data?.internships)
        ? res.data.internships
        : [],
      trainings: Array.isArray(res.data?.trainings) ? res.data.trainings : [],
      items: Array.isArray(res.data?.items) ? res.data.items : [],
    })
  );
}

export function setSavedItem(traineeId, itemType, itemId, saved) {
  return AxiosInstance.post(`companies/trainee/${traineeId}/saved/toggle/`, {
    item_type: itemType,
    item_id: Number(itemId),
    saved,
  }).then((res) => Boolean(res.data?.saved));
}

/**
 * Bookmark toggle for a job / internship / training (course batch).
 * Renders nothing when no trainee is signed in.
 */
export default function SaveButton({ itemType, itemId, variant = "block" }) {
  const traineeId = localStorage.getItem("traineeId");
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!traineeId || !itemId) return undefined;
    let active = true;
    fetchSavedItems(traineeId)
      .then(({ items }) => {
        if (!active) return;
        setSaved(
          items.some(
            (it) =>
              it.item_type === itemType && String(it.item_id) === String(itemId)
          )
        );
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [traineeId, itemType, itemId]);

  if (!traineeId || !itemId) return null;

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    const next = !saved;
    setSaved(next);
    setBusy(true);
    try {
      setSaved(await setSavedItem(traineeId, itemType, itemId, next));
    } catch (err) {
      setSaved(!next);
      alert(err.response?.data?.error || "Could not update saved items.");
    } finally {
      setBusy(false);
    }
  };

  const label = saved ? "Saved" : "Save";
  const Icon = saved ? BsBookmarkFill : BsBookmark;

  if (variant === "icon") {
    return (
      <button
        type="button"
        className={`als-save-icon${saved ? " is-saved" : ""}`}
        onClick={toggle}
        disabled={busy}
        aria-pressed={saved}
        aria-label={saved ? "Remove from saved" : "Save"}
        title={saved ? "Remove from saved" : "Save"}
      >
        <Icon />
      </button>
    );
  }

  return (
    <button
      type="button"
      className={`als-save-btn${saved ? " is-saved" : ""}`}
      onClick={toggle}
      disabled={busy}
      aria-pressed={saved}
    >
      <Icon /> {label}
    </button>
  );
}
